import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';


export interface ConfirmOTPResponse extends APIResponse 
{
    
}

export class ConfirmOTPResponseDtoImpl extends APIResponseDtoImpl implements ConfirmOTPResponse 
{
   

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotpresponse.tsx